import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

function getActiveSection(location) {
  if (location.pathname === "/about") {
    return "about";
  }

  const searchParams = new URLSearchParams(location.search);
  return (searchParams.get("section") || "home").toLowerCase();
}

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeSection = getActiveSection(location);

  const navItems = [
    { label: "Home", key: "home", onClick: () => navigate("/") },
    {
      label: "Presentations",
      key: "presentations",
      onClick: () => navigate("/?section=presentations"),
    },
  ];

  return (
    <header className="site-header">
      <div className="site-header-bar">
        <button className="brand-mark" onClick={() => navigate("/")}>
          <img className="brand-mark-image" src="/brand-avatar.jpeg" alt="Prashant Rai mark" />
        </button>
        <nav className="site-nav" aria-label="Primary">
          {navItems.map((item) => {
            const isActive = item.key === activeSection;

            return (
              <button
                key={item.key}
                className={isActive ? "nav-item active" : "nav-item"}
                onClick={item.onClick}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
